import { Button } from "@heroui/react";
import { IconPlus } from "@tabler/icons-react";

const PlusLineButton = ({ onClick }) => {
    return (
        <Button variant="flat" onPress={onClick} fullWidth={true}>
            <IconPlus stroke={1.5} />
        </Button>
    );
};

export { PlusLineButton };
